/**
 * Viability app — /apps/viability/*
 *
 * One job: is the plan deliverable — and when it is, when can it launch?
 * Three screens: Home (pick the question), Check (viability — rough-cut
 * capacity), Launch (time-phased — the three additional steps). Both flows
 * share one scenario and one engine; the app is a guided projection of
 * /planning/engine, never a second engine.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import { ModuleRouteGuard } from '@/components/guards/ModuleRouteGuard';
import ViabilityHomeScreen from './ViabilityHomeScreen';
import ViabilityCheckScreen from './ViabilityCheckScreen';
import LaunchPlanScreen from './LaunchPlanScreen';

export default function ViabilityApp() {
  const app = getAppDefinition('viability')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<ViabilityHomeScreen />} />
        <Route path="check" element={<ViabilityCheckScreen />} />
        {/* Launch planning is the time_phased_planning module: the home card
            hides when it is off, and so does the address (§2.7 — the one guard). */}
        <Route
          path="launch"
          element={
            <ModuleRouteGuard moduleKey="time_phased_planning" redirectTo="/apps/viability">
              <LaunchPlanScreen />
            </ModuleRouteGuard>
          }
        />
        <Route path="*" element={<Navigate to="/apps/viability" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
